import React from 'react'
import PropTypes from 'prop-types'
import Expand from 'material-ui/svg-icons/maps/zoom-out-map'
import Download from 'material-ui/svg-icons/action/get-app'
import cx from 'classnames'
import styles from './styles/media-within-text.css'

const getOrientation = (imageUrl) => {
  const img = new Image()
  img.src = imageUrl
  return img.naturalWidth < img.naturalHeight ? 'portrait' : 'landscape'
}

const MediaWithinText = ({ url, type, handleExpandedMessage }) => {
  const mediaBgStyle = {
    backgroundImage: `url(${url})`,
  }
  const iconDownloadStyles = cx(styles.icon, styles.iconDownload, (type === 'fromPatient' ? styles.iconFromPatient : styles.iconToPatient))
  const iconExpandStyles = cx(styles.icon, styles.iconExpand, (type === 'fromPatient' ? styles.iconFromPatient : styles.iconToPatient))
  const buttonStyles = cx(styles.button, (type === 'fromPatient' ? styles.fromPatientButton : styles.toPatientButton))
  const imageStyles = cx(styles.image, styles[getOrientation(url)])

  return (
    <div
      className={imageStyles}
      style={mediaBgStyle}
    >
      <div className={styles.buttonsContainer}>
        <a
          className={buttonStyles}
          href={url}
          download
          target="_blank"
        >
          <Download className={iconDownloadStyles} />
        </a>
        <div
          className={buttonStyles}
          onClick={() => handleExpandedMessage(url)}
        >
          <Expand className={iconExpandStyles} />
        </div>
      </div>
    </div>
  )
}
MediaWithinText.propTypes = {
  url: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  handleExpandedMessage: PropTypes.func.isRequired,
}

export default MediaWithinText



// WEBPACK FOOTER //
// ./src/components/Messages/MediaWithinText.js